export default __webpack_public_path__ + "static/media/977.ee16ec8a.gif";